import type { ManagerEvent, UpcomingGigFormState } from "@/types/manager";

const DATE_ONLY_PATTERN = /^\d{4}-\d{2}-\d{2}$/;

const toDateInputValue = (value?: string | null) => {
  if (!value) return "";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  return parsed.toISOString().slice(0, 10);
};

const toTimeInputValue = (value?: string | null) => {
  if (!value) return "";
  const parsed = new Date(value);
  if (Number.isNaN(parsed.getTime())) return "";
  return parsed.toISOString().slice(11, 16);
};

const combineDateAndTime = (dateValue: string, timeValue: string) => {
  if (!dateValue) return null;
  const parsed = timeValue ? new Date(`${dateValue}T${timeValue}`) : new Date(`${dateValue}T00:00:00`);
  if (Number.isNaN(parsed.getTime())) return null;
  return parsed.toISOString();
};

const currencyToNumber = (value: string) => {
  if (!value || !value.trim()) return null;
  const cleaned = value.replace(/[$,%\s]/g, "");
  const numeric = Number(cleaned);
  return Number.isFinite(numeric) ? numeric : null;
};

const percentageToNumber = (value: string) => {
  if (!value || !value.trim()) return null;
  const cleaned = value.replace(/[%\s]/g, "");
  const numeric = Number(cleaned);
  return Number.isFinite(numeric) ? numeric : null;
};

export const createUpcomingGigFormDefaults = (): UpcomingGigFormState => ({
  event_date: "",
  event_time: "",
  city: "",
  state: "",
  venue: "",
  guarantee: "",
  split: "",
  artist_percentage: "",
  marketing: "",
  sound: "",
  house: "",
  ticket_gross: "",
  merch_revenue: "",
  attendance: "",
  notes: "",
  show_id: null,
  venue_contact_id: null,
  venue_contact_label: "",
  contact_id: null,
  contact_label: "",
  ledger_entry_id: null,
});

export const eventToUpcomingGigForm = (event?: ManagerEvent | null): UpcomingGigFormState => {
  if (!event) {
    return createUpcomingGigFormDefaults();
  }
  return {
    event_date: toDateInputValue(event.event_date),
    event_time: toTimeInputValue(event.event_date),
    city: event.city ?? "",
    state: event.state ?? "",
    venue: event.venue ?? event.name ?? "",
    guarantee: event.guarantee_amount != null ? String(event.guarantee_amount) : "",
    split: event.split_terms ?? "",
    artist_percentage: event.artist_percentage != null ? String(event.artist_percentage) : "",
    marketing: "",
    sound: event.sound_expenses != null ? String(event.sound_expenses) : "",
    house: event.house_expenses != null ? String(event.house_expenses) : "",
    ticket_gross: event.ticket_gross != null ? String(event.ticket_gross) : "",
    merch_revenue: event.merch_revenue != null ? String(event.merch_revenue) : "",
    attendance: event.attendance != null ? String(event.attendance) : "",
    notes: event.notes ?? "",
    show_id: event.show_id ?? event.external_id ?? event.id ?? null,
    venue_contact_id: event.crm_venue_id ?? null,
    venue_contact_label: event.crm_venue_name ?? "",
    contact_id: event.crm_contact_id ?? null,
    contact_label: event.crm_contact_name ?? "",
    ledger_entry_id: event.accounting_entry_id ?? null,
  };
};

export { combineDateAndTime, currencyToNumber, percentageToNumber };
